module.exports = __webpack_public_path__ + "static/img/s9.cb900b21.png";